import { FC, useState } from "react";
import { CircleProps } from "./types";

const Circle: FC<CircleProps> = ({ circle, imageDimensions, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);

  const circleSize = ((circle.radius ?? 5) / 100) * imageDimensions.width;

  return (
    <div
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        position: "absolute",
        left: `${((circle.x ?? 50) / 100) * imageDimensions.width}px`,
        top: `${((circle.y ?? 50) / 100) * imageDimensions.height}px`,
        width: `${circleSize}px`,
        height: `${circleSize}px`,
        borderRadius: "50%",
        transform: "translate(-50%, -50%)",
        cursor: "pointer",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        overflow: "hidden",
      }}
    >
      {(isHovered ? circle.details.hoverIcon : circle.details.nonHoverIcon) && (
        <img
          src={
            isHovered ? circle.details.hoverIcon : circle.details.nonHoverIcon
          }
          alt=""
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
          }}
        />
      )}
    </div>
  );
};

// Edit Profile
// Date personale Nume, prenume, data nasterii, oras, nr telefon

export default Circle;
